<template>
  <div>
    <header
      :class="{
        application:
          $route.name != 'Home' &&
          $route.name != 'Register' &&
          $route.name != 'Login',
      }"
    >
      <div class="contain">
        <img
          v-if="
            $route.name != 'Application Approval' &&
              $route.name != 'Soft Underwriting'
          "
          @click="goTo('/')"
          src="@/assets/img/logo.svg"
        />

        <template
          v-if="
            $route.name == 'Application Approval' ||
              $route.name == 'Soft Underwriting'
          "
        >
          <img src="@/assets/img/logo.svg" />
          <button @click="saveForm()" class="btn text-btn save">
            Finish Later
          </button>
        </template>

        <button
          v-if="
            $route.name == 'Dashboard' &&
              this.$store.state.application_approval_phase != 'start'
          "
          @click="logout()"
          class="btn text-btn save"
        >
          Logout
        </button>

        <nav>
          <router-link to="/application">Get Started</router-link>
          <router-link to>About Us</router-link>
          <router-link to="/login">Login</router-link>
        </nav>
        <img
          @click="mobile = true"
          class="profile-icon"
          src="@/assets/img/hamburger.svg"
        />
      </div>
    </header>

    <transition name="fade">
      <div v-if="mobile" class="mobile-nav">
        <p @click="mobile = false" class="close">x</p>
        <div class="links">
          <router-link to="/application">Get Started</router-link>
          <router-link to>About Us</router-link>
          <router-link to>Login</router-link>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { db, auth } from "@/config/firebaseInit";
import firebase from "firebase";

export default {
  name: "heading",
  components: {},
  data() {
    return {
      mobile: false,
    };
  },
  mounted() {},
  created() {},
  firestore() {
    return {};
  },
  methods: {
    logout() {
      firebase
        .auth()
        .signOut()
        .then(
          () => {
            this.$store.dispatch("signOut");
            localStorage.clear();
            this.goTo("/");
            window.location.reload();
          },
          function(error) {
            // An error happened.
          }
        );
    },
    saveForm() {
      this.goTo("/dashboard");
      let step;
      let status;
      let id = this.$store.state.user_id;
      let user = this.$store.state.user;

      if (this.$store.state.phase == "Application Approval") {
        status = this.$store.state.soft_underwriting_phase;
      } else if (this.$store.state.phase == "Soft Underwriting") {
        status = this.$store.state.soft_underwriting_phase;
      }
      user.status = status;
      user.step = this.$store.state.application_approval_step;

      db.collection("user")
        .doc(id)
        .set(user, { merge: true })
        .then(() => {});
    },
  },
  watch: {},
};
</script>

<style lang="scss">
header {
  background: white;
  border-bottom: 2px solid #eaeaea;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 99;
  .contain {
    position: relative;
    z-index: 11;
    padding: 15px 100px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    @media screen and (max-width: 1000px) {
      padding: 15px 50px;
    }
    @media screen and (max-width: 700px) {
      padding: 15px 30px;
    }
    img {
      height: 38px;
      cursor: pointer;
    }
    img.profile-icon {
      height: 19px;
      display: none;
      cursor: pointer;
      @media screen and (max-width: 700px) {
        display: block;
      }
    }
  }
  &.application {
    .contain {
      justify-content: center;
      @media screen and (max-width: 700px) {
        justify-content: space-between;
        display: flex;
      }
    }
    nav {
      display: none;
    }
    .profile-icon {
      display: none !important;
    }
  }

  nav {
    @media screen and (max-width: 700px) {
      display: none;
    }
  }
}

.mobile-nav {
  position: fixed;
  left: 0;
  top: 0;
  height: 100%;
  width: 100%;
  padding: 30px;
  z-index: 10;
  background-color: rgba(8, 91, 209, 0.9);
  .links {
    display: flex;
    flex-direction: column;
    padding-top: 100px;
    a {
      color: white;
      font-weight: bold;
      font-size: 35px;
      margin-bottom: 15px;
      text-decoration: none;
      cursor: pointer;
      transition: transform 0.3s;
      &:hover {
        transform: scale(0.99);
      }
    }
  }
  p {
    color: white;
    cursor: pointer;
    padding: 15px 20px;
    font-size: 30px;
    position: fixed;
    top: 0;
    right: 0;
    margin: 0;
    font-weight: bold;
    opacity: 1;
    &.close {
      position: fixed;
      top: 70px;
      right: 30px;
      opacity: 0.5;
      font-weight: normal;
    }
  }
}

.offclick {
  position: fixed;
  z-index: 9998;
  width: 100%;
  height: 100%;
}

.save {
  font-size: 13px !important;
  position: absolute;
  right: 30px;
}
</style>
